import styled from '@emotion/styled';
import { customAssetOrSrc } from '@core/assets/customAssetOrSrc';
import { useContextTranslation } from '@core/i18n';
import { useContextParams } from '@core/params/context';
import { CaretLeft } from './CaretLeft';
import { CaretRight } from './CaretRight';
const Button = styled.button `
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 0.8rem;
  padding: 20px;
  text-decoration: none;
  width: auto;

  &:focus,
  &:focus-visible {
    outline-offset: -3px;
  }
  z-index: 1;
`;
const Arrow = styled.span `
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  width: 40px;
  height: 40px;

  background-color: rgba(64 64 64 / 50%);
  border-radius: 50%;

  [dir='rtl'] & {
    transform: scaleX(-1);
  }
`;
/**
 * Next/Previous navigation buttons (chevrons)
 */
export const NavButton = ({ isRight, title, ...rest }) => {
    const params = useContextParams();
    const { t } = useContextTranslation();
    return (<Button {...rest} aria-label={title || (isRight ? t('Next Card') : t('Previous Card'))}>
      <Arrow>
        {!isRight &&
            (customAssetOrSrc(params?.ui_asset_previous) || (<CaretLeft aria-hidden label=""/>))}
        {isRight &&
            (customAssetOrSrc(params?.ui_asset_next) || (<CaretRight aria-hidden label=""/>))}
      </Arrow>
    </Button>);
};
